import "simplebar-react/dist/simplebar.min.css";
import "react-lazy-load-image-component/src/effects/blur.css";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import Router from "./routes";
// theme
import ThemeProvider from "./theme";
import SnackbarProvider from "./components/snackbar";
import ScrollToTop from "./components/scroll-to-top";
import { MotionLazyContainer } from "./components/animate";
import { ThemeSettings, SettingsProvider } from "./components/settings";
// scroll bar
import "simplebar-react/dist/simplebar.min.css";

// lazy image
import "react-lazy-load-image-component/src/effects/blur.css";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { Auth0SPAViewModel, AuthViewModel } from "./sections/auth";
import { ApolloViewModel } from "./sections/apollo";
import { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import { LicenseInfo } from "@mui/x-license-pro";
import "react-toastify/dist/ReactToastify.css";
// import "sweetalert2/src/sweetalert2.scss";

import { EmergencyContactProvider } from "./pages/general/emergency-contacts/EmergencyContactContext";
import { EmployeeProfileProvider } from "./pages/employee-profile/EmployeeProfileContext";
import { FormsProvider } from "./pages/general/forms/FormContext";
import { CustomerSitesProvider } from "./pages/general/CustomerSitesContext";
import { ScheduleProviderProvider } from "./pages/schedules/ScheduleProvider";
import "./custom.css";
import { InvalidTokenDialog } from "./components/auth/InvalidTokenDialog";

// import "@mantine/dates/styles.css";

LicenseInfo.setLicenseKey(
  "cdd47a722433c952e9d58869633db66aTz0xMTcwNzgsRT0xNzg1NzE1MTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI="
);

// ----------------------------------------------------------------------

export default function App() {
  // useEffect(() => {
  //   if (googleToken) {
  //     fetch(
  //       `https://www.googleapis.com/gmail/v1/users/me/messages?access_token=${googleToken}`
  //     )
  //       .then((response) => response.json())
  //       .then((data) => {
  //         const promises = data?.messages?.map((item) => {
  //           return fetch(
  //             `https://gmail.googleapis.com/gmail/v1/users/me/messages/${item.id}?access_token=${googleToken}`
  //           ).then((res) => res.json());
  //         });
  //         Promise.all(promises).then((data) => console.log(data));
  //       });
  //   }
  // }, [googleToken]);

  let code = window?.location?.search;
  var newStr = code.replace("?code=", "");

  useEffect(() => {
    if (newStr) {
      const verify = newStr.split("&");
      if (verify[1] === "state=outlook") {
        localStorage.setItem("outlook_code", verify[0]);
      }
      //  else {
      //   getaccessTokenSms(verify[0]);
      // }
    }
  }, [newStr]);

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Auth0SPAViewModel>
        <ApolloViewModel>
          <AuthViewModel>
            <HelmetProvider>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <SettingsProvider>
                  <FormsProvider>
                    <EmployeeProfileProvider>
                      <CustomerSitesProvider>
                        <EmergencyContactProvider>
                          <ScheduleProviderProvider>
                            <BrowserRouter>
                              <ScrollToTop />
                              <MotionLazyContainer>
                                <ThemeProvider>
                                  <ThemeSettings>
                                    <SnackbarProvider>
                                      <InvalidTokenDialog />
                                      <Router />
                                    </SnackbarProvider>
                                  </ThemeSettings>
                                </ThemeProvider>
                              </MotionLazyContainer>
                            </BrowserRouter>
                          </ScheduleProviderProvider>
                        </EmergencyContactProvider>
                      </CustomerSitesProvider>
                    </EmployeeProfileProvider>
                  </FormsProvider>
                </SettingsProvider>
              </LocalizationProvider>
            </HelmetProvider>
          </AuthViewModel>
        </ApolloViewModel>
      </Auth0SPAViewModel>
    </>
  );
}
